import { render, staticRenderFns } from "./GdMap.vue?vue&type=template&id=20506a87&"
import script from "./GdMap.vue?vue&type=script&lang=js&"
export * from "./GdMap.vue?vue&type=script&lang=js&"
import style0 from "./GdMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports